"use client";

import { NextIntlClientProvider, type AbstractIntlMessages } from "next-intl";
import { ReactNode } from "react";

export interface NextIntlWrapperProps {
  children: ReactNode;
  locale: string;
  messages: AbstractIntlMessages;
}

export default function NextIntlWrapper({
  children,
  locale,
  messages,
}: NextIntlWrapperProps) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone="Europe/Kaliningrad"
    >
      {children}
    </NextIntlClientProvider>
  );
}
